import { useEffect, useState } from "react";
import { apiFetch, ButtonLink, Loading } from "@iga/ui";

/** Landing page of the verification link in the sign-up e-mail. English only (no tenant yet). */
export function SignupVerify() {
  const token = new URLSearchParams(window.location.search).get("token") ?? "";
  const [state, setState] = useState<{ status: "working" } | { status: "ok"; slug: string; result: string } | { status: "error"; message: string }>({ status: "working" });
  useEffect(() => {
    apiFetch<{ slug: string; status: string }>("/api/public/tenant-requests/verify", { method: "POST", json: { token } })
      .then((r) => setState({ status: "ok", slug: r.slug, result: r.status }))
      .catch((e) => setState({ status: "error", message: e instanceof Error ? e.message : "The link could not be verified" }));
  }, [token]);
  if (state.status === "working") return <Loading label="Verifying…" />;
  return (
    <div className="flex min-h-full items-center justify-center bg-brand-tint p-6"><div className="flex w-full max-w-md flex-col gap-3 rounded-dialog bg-surface p-7 shadow-e3">
      {state.status === "ok" ? (<>
        <h1 className="text-h2">E-mail confirmed</h1>
        <p className="text-fg-2">{state.result === "approved" || state.result === "provisioned"
          ? `Your organisation "${state.slug}" is being created. Within a minute you will receive an e-mail with a link to set your administrator password.`
          : `Your request for "${state.slug}" is waiting for approval by the platform operator. You will receive an e-mail when it is ready.`}</p>
      </>) : (<>
        <h1 className="text-h2">The link could not be verified</h1>
        <p className="font-semibold text-bad" role="alert">{state.message}</p>
        <p className="text-small text-fg-3">Ask for a new sign-up e-mail, or contact the platform operator.</p>
      </>)}
      <ButtonLink href="/" variant="secondary" size="touch" className="self-start">Back to sign-in</ButtonLink>
    </div></div>
  );
}
